/**
 * 区域管理
 */
<template>
  <div>
    <div style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>维保日志</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div>
        <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
          <el-form-item label="车辆编号:" v-if="show">
            <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="故障程度:">
            <el-select size="small" clearable filterable v-model="formInline.fault_level_id" placeholder="请选择故障程度">
              <el-option v-for="item in faultLevelOptions" :key="item.id" :label="item.dict_value" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="故障类型:">
            <el-select size="small" clearable filterable v-model="formInline.fault_type_id" placeholder="请选择故障类型">
              <el-option v-for="item in faultTypeOptions" :key="item.id" :label="item.dict_value" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维护时间:">
            <div class="block">
              <el-date-picker size="small" v-model="formInline.maintenance_time_str" value-format="yyyy-MM-dd" type="date"
                placeholder="选择维护时间">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="success" icon="el-icon-plus" @click="addRepair()"
              v-if="check_auth('/web/repair_maintenance/add')">添加日志</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="exportSelect()"
              v-if="check_auth('/web/repair_maintenance/export_selected')">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <div style="margin-top: 20px">
        <el-table :data="listData" ref="multipleTable" border element-loading-text="拼命加载中" style="width: 100%"
          @selection-change="handleSelectionChange" row-key="id">
          <el-table-column type="selection" reserve-selection align="center" width="55">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="id" label="ID" width="80"></el-table-column>
          <el-table-column align="center" label-aligin="center" prop="vin" min-width="200" label="车辆编号">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="maintenance_man" label="维护人" min-width="150">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="phone" min-width="200" label="联系方式">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="fault_level" min-width="200" label="故障程度">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="fault_type" min-width="200" label="故障类型">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="maintenance_time_str" min-width="200" label="维护时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="fault_description" min-width="250" label="故障信息描述">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="fault_solution_description" min-width="250"
            label="故障解决描述"></el-table-column>

          <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="200"
            v-if="check_auth('/web/repair_maintenance/update') || check_auth('/web/repair_maintenance/delete')">
            <template slot-scope="scope">
              <el-button round size="mini" @click="editRepair(scope.row)"
                v-if="check_auth('/web/repair_maintenance/update')">编辑</el-button>
              <el-button round size="mini" type="danger" @click="delRepair(scope.row)"
                v-if="check_auth('/web/repair_maintenance/delete')">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 添加界面 -->
      <el-dialog :title="addtitle" :visible.sync="addFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <div>
          <el-form label-width="17%" :model="addForm" :rules="rules" ref="addForm">
            <el-form-item label="车辆编号" prop="vin">
              <el-select size="small" style="width: 100%" clearable filterable v-model="addForm.vin" :disabled="disabled"
                placeholder="请选择车辆编号">
                <el-option v-for="item in addVinOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护人" prop="maintenance_man">
              <el-input size="small" style="width: 100%" clearable v-model="addForm.maintenance_man" auto-complete="off"
                placeholder="请输入维护人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input size="small" style="width: 100%" clearable v-model="addForm.phone" auto-complete="off"
                placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item label="故障程度" prop="fault_level_id">
              <el-select size="small" style="width: 100%" clearable filterable v-model="addForm.fault_level_id"
                placeholder="请选择故障程度">
                <el-option v-for="item in addFaultLevelOptions" :key="item.id" :label="item.dict_value" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="故障类型" prop="fault_type_id">
              <el-select size="small" style="width: 100%" clearable filterable v-model="addForm.fault_type_id"
                placeholder="请选择故障类型">
                <el-option v-for="item in addFaultTypeOptions" :key="item.id" :label="item.dict_value" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护时间" prop="maintenance_time_str">
              <div class="block">
                <el-date-picker size="small" style="width: 100%" v-model="addForm.maintenance_time_str"
                  value-format="yyyy-MM-dd HH:mm:ss" default-time="08:00:00" type="datetime" placeholder="选择维护时间">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="故障信息描述" prop="fault_description">
              <el-input size="small" type="textarea" :rows="3" style="width: 100%" v-model="addForm.fault_description"
                auto-complete="off" placeholder="请输入故障信息描述"></el-input>
            </el-form-item>
            <el-form-item label="故障解决描述" prop="fault_solution_description">
              <el-input size="small" type="textarea" :rows="3" style="width: 100%"
                v-model="addForm.fault_solution_description" auto-complete="off" placeholder="请输入故障解决描述"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="addtitle" @click="submitAdd('addForm')">保存
          </el-button>
          <el-button size="mini" @click="closeDialog('addForm')">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog :title="edittitle" :visible.sync="editFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <div>
          <el-form label-width="17%" :model="editForm" :rules="rules" ref="editForm">
            <el-form-item label="车辆编号" prop="vin">
              <el-select size="small" style="width: 100%" clearable filterable v-model="editForm.vin" :disabled="disabled"
                placeholder="请选择车辆编号">
                <el-option v-for="item in editVinOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护人" prop="maintenance_person">
              <el-input size="small" v-model="editForm.maintenance_man" style="width: 100%" auto-complete="off" clearable
                placeholder="请输入维护人">
              </el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input size="small" v-model="editForm.phone" auto-complete="off" style="width: 100%" clearable
                placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item label="故障程度" prop="fault_level_id">
              <el-select size="small" style="width: 100%" clearable filterable @change="getEditFaultLevel()"
                v-model="editForm.fault_level_id" placeholder="请选择故障程度">
                <el-option v-for="item in editFaultLevelOptions" :key="item.id" :label="item.dict_value" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="故障类型" prop="fault_type_id">
              <el-select size="small" style="width: 100%" clearable filterable @change="getEditFaultType()"
                v-model="editForm.fault_type_id" placeholder="请选择故障类型">
                <el-option v-for="item in editFaultTypeOptions" :key="item.id" :label="item.dict_value" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护时间" prop="maintenance_time_str">
              <div class="block">
                <el-date-picker size="small" style="width: 100%" v-model="editForm.maintenance_time_str"
                  value-format="yyyy-MM-dd HH:mm:ss" default-time="08:00:00" type="datetime" placeholder="选择维护时间">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="故障信息描述" prop="fault_description">
              <el-input size="small" type="textarea" :rows="3" style="width: 100%" v-model="editForm.fault_description"
                auto-complete="off" placeholder="请输入故障信息描述"></el-input>
            </el-form-item>
            <el-form-item label="故障解决描述" prop="fault_solution_description">
              <el-input size="small" type="textarea" :rows="3" style="width: 100%"
                v-model="editForm.fault_solution_description" auto-complete="off" placeholder="请输入故障解决描述"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="edittitle" @click="submitForm('editForm')">
            保存</el-button>
          <el-button size="mini" @click="closeDialog('addForm')">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  get_repair_maintenance_list,
  get_fault_level_list,
  get_fault_type_list,
  get_vin_list,
  get_repair_maintenance_add,
  get_repair_maintenance_one,
  get_repair_maintenance_edit,
  get_export_repairLog,
  get_repair_maintenance_del,
} from "../../api/projectLog/repairLog";
import { auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      loading: false, //是显示加载
      idsval: [],
      ids: [],
      show: true,
      disabled: false,
      faultLevelOptions: [],
      addFaultLevelOptions: [],
      editFaultLevelOptions: [],
      faultTypeOptions: [],
      addFaultTypeOptions: [],
      editFaultTypeOptions: [],
      addVinOptions: [],
      editVinOptions: [],
      addtitle: "添加",
      edittitle: "修改",
      addForm: {
        id: "",
        vin: "",
        maintenance_man: "",
        phone: "",
        fault_level_id: "",
        fault_level: "",
        fault_type_id: "",
        fault_type: "",
        fault_description: "",
        fault_solution_description: "",
        maintenance_time_str: "",
      },
      editForm: {
        id: "",
        vin: "",
        maintenance_man: "",
        phone: "",
        fault_level_id: "",
        fault_level: "",
        fault_type_id: "",
        fault_type: "",
        fault_description: "",
        fault_solution_description: "",
        maintenance_time_str: "",
      },
      // rules表单验证
      rules: {
        vin: [{ required: true, message: "请选择车辆编号", trigger: "change" }],
        maintenance_man: [
          { required: true, message: "请输入维保人", trigger: "change" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请输入维保人，如：李四",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "change" },
          {
            pattern: /^[1][34578]\d{9}$/,
            message: "请输入正确的手机号，如：136****5645",
            trigger: "change",
          },
        ],
        fault_level_id: [
          { required: true, message: "请选择故障等级", trigger: "change" },
        ],
        fault_type_id: [
          { required: true, message: "请选择故障类型", trigger: "change" },
        ],
        fault_description: [
          { required: true, message: "请输入故障信息描述", trigger: "blur" },
        ],
        fault_solution_description: [
          { required: true, message: "请输入故障解决描述", trigger: "blur" },
        ],
        maintenance_time_str: [
          { required: true, message: "请选择维保时间", trigger: "change" },
        ],
      },

      formInline: {
        id: "",
        vin: "",
        maintenance_man: "",
        fault_level_id: "",
        fault_type_id: "",
        maintenance_time_str: "",
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      listData: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.getFaultLevel();
    this.getFaultType();
  },
  props: {
    vin: String,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    check_auth(val) {
      return auth(val);
    },
    getFaultLevel() {
      get_fault_level_list().then((res) => {
        if (res["code"] === 0) {
          this.faultLevelOptions = res.data;
        }
      });
    },
    getFaultType() {
      get_fault_type_list().then((res) => {
        if (res["code"] === 0) {
          this.faultTypeOptions = res.data;
        }
      });
    },
    // 事故列表
    getData() {
      this.show = this.vin == undefined ? true : false;
      if (!this.show) {
        this.formInline.vin = this.vin == undefined ? "" : this.vin;
      }
      get_repair_maintenance_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          this.pageparm.total = res.data.total;
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    // 添加 故障等级列表
    getAddFaultLevel() {
      get_fault_level_list().then((res) => {
        if (res["code"] === 0) {
          this.addFaultLevelOptions = res.data;
        }
      });
    },
    // 添加 故障类别列表
    getAddFaultType() {
      get_fault_type_list().then((res) => {
        if (res["code"] === 0) {
          this.addFaultTypeOptions = res.data;
        }
      });
    },
    // 添加 车辆列表
    getAddCar() {
      get_vin_list().then((res) => {
        if (res["code"] === 0) {
          this.addVinOptions = res.data;
        }
      });
    },
    //显示添加界面
    addRepair() {
      this.addFormVisible = true;
      this.getAddFaultLevel();
      this.getAddFaultType();
      this.getAddCar();
      this.addForm = {};
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
        this.addForm.vin = this.vin;
      }
    },
    // 添加信息
    submitAdd(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_repair_maintenance_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getData();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑 故障等级列表
    getEditFaultLevel() {
      get_fault_level_list().then((res) => {
        if (res["code"] === 0) {
          this.editFaultLevelOptions = res.data;
        }
      });
    },
    // 编辑 故障类别列表
    getEditFaultType() {
      get_fault_type_list().then((res) => {
        if (res["code"] === 0) {
          this.editFaultTypeOptions = res.data;
        }
      });
    },
    // 编辑 车辆列表
    getEditCar() {
      get_vin_list().then((res) => {
        if (res["code"] === 0) {
          this.editVinOptions = res.data;
        }
      });
    },
    //显示编辑界面
    editRepair(row) {
      this.edittitle = "修改";
      this.getEditFaultLevel();
      this.getEditFaultType();
      this.getEditCar();
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      get_repair_maintenance_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.editFormVisible = true;
        }
      });
    },
    // 修改保存
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_repair_maintenance_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            if (res["code"] === 0) {
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出
    getExport(id) {
      get_export_repairLog(id)
        .then((res) => {
          if (res["code"] == undefined) {
            // 这里根据后端返回使用res或res.data
            var blob = new Blob([res], {
              type: "application/ms-excel",
            });
            var elink = document.createElement("a");
            elink.download = "维保日志" + ".xlsx";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click(); //点击下载
            URL.revokeObjectURL(elink); //释放掉blob对象
            document.body.removeChild(elink); //下载完成移除元素
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    exportSelect() {
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
      }
      var str = this.ids.join(",");
      if (this.idsval.length > 0) {
        this.getExport(str);
      } else {
        this.$message.error("下载失败，先选择需要下载的数据");
      }
      this.toggleRowSelect();
    },
    // 删除
    delRepair(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_repair_maintenance_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/projectLog/repairLog_mn.vue